import { render, staticRenderFns } from "./EmailingRecipientsDialog.vue?vue&type=template&id=06ffacca"
import script from "./EmailingRecipientsDialog.vue?vue&type=script&lang=js"
export * from "./EmailingRecipientsDialog.vue?vue&type=script&lang=js"
import style0 from "./EmailingRecipientsDialog.vue?vue&type=style&index=0&id=06ffacca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports